import { render, staticRenderFns } from "./CoreHeader.vue?vue&type=template&id=0e77d16c&scoped=true&"
import script from "./CoreHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreHeader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CoreHeader.vue?vue&type=style&index=0&id=0e77d16c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e77d16c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e77d16c')) {
      api.createRecord('0e77d16c', component.options)
    } else {
      api.reload('0e77d16c', component.options)
    }
    module.hot.accept("./CoreHeader.vue?vue&type=template&id=0e77d16c&scoped=true&", function () {
      api.rerender('0e77d16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/CoreHeader.vue"
export default component.exports